// @generated
import { PapiGallection } from '@wix/da-papi-types';

export const collections: PapiGallection[] = [
  {
    type: 'collection',
    name: 'Tutos',
    richDescription: undefined,

    owner: {
      username: 'Nahoria',
      usericon: 'https://a.deviantart.net/avatars/n/a/nahoria.gif?5',
      type: 'premium',
      userId: 40391978,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 404,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/bokuman/art/Tutorial-706493243',
      title: 'Tutorial',
      author: {
        username: 'bokuman',
        usericon: 'https://a.deviantart.net/avatars/b/o/bokuman.jpg?1',
        type: 'premium',
        userId: 2795102,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 12,
        favourites: 1353,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/fDjkPuSaaQGXv1CyPS6fxEv_ySE=/fit-in/150x150/filters:no_upscale():origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 150,
          width: 135,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/w4KP5cybOG0nV0P975KM5fQCufI=/300x200/filters:fixed_height(100,100):origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 200,
          width: 179,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/PA_ehtd-m6GM5y3I9zj8ptKydDY=/fit-in/300x900/filters:no_upscale():origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 335,
          width: 300,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/0VgChp100-Pxa4_I7YnjbMRV0L4=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 250,
          width: 224,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/gTb1NXNkOV4lNh2XB6alXwVo6_o=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 350,
          width: 314,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/7JepEtEzkaDif1YV7MUXut_h66w=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 400,
          width: 359,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 944,
          width: 846,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/e37f/th/pre/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 944,
          width: 846,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/8d83/i/2017/269/7/8/tutorial_by_bokuman-dbomlob.jpg',
          height: 1142,
          width: 1024,
          transparency: false,
          filesize: 175176,
          isDefault: false,
        },
      ],
      deviationId: 706493243,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-10-02T09:00:09-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 70605345,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Inspiration',
    richDescription: undefined,

    owner: {
      username: 'Nahoria',
      usericon: 'https://a.deviantart.net/avatars/n/a/nahoria.gif?5',
      type: 'premium',
      userId: 40391978,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 825,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/nyesth/art/Raffle-Prize-AverySanX-755941489',
      title: '[Raffle Prize] AverySanX',
      author: {
        username: 'Nyesth',
        usericon: 'https://a.deviantart.net/avatars/n/y/nyesth.png?3',
        type: 'premium',
        userId: 34100302,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 19,
        favourites: 201,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/WTqjF9Df5ojlB5bCvNpc0kjybfA=/fit-in/150x150/filters:no_upscale():origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 150,
          width: 122,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/XbdINzAw9mjUgxmZ34LuSLWBm_I=/300x200/filters:fixed_height(100,100):origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 200,
          width: 162,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/_4BqQoVFcCdJZW_jFUrzAVJErT0=/fit-in/300x900/filters:no_upscale():origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 370,
          width: 300,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/Bi0DQFfGmgc1awDhm0wbbAk8ZII=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 250,
          width: 203,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/6DXrPLCTYSm7vXUHCZj0W-mHB5o=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 350,
          width: 284,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/tVr4UjW94-3BEUnMziH8T7cUlSI=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/42eb/th/pre/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 400,
          width: 324,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/983e/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 913,
          width: 740,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/983e/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 913,
          width: 740,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/983e/f/2018/204/d/9/afverylow_by_nyesth-dci2g6p.png',
          height: 913,
          width: 740,
          transparency: true,
          filesize: 646671,
          isDefault: false,
        },
      ],
      deviationId: 755941489,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-07-23T13:11:47-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 74147181,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Stuff',
    richDescription: undefined,

    owner: {
      username: 'Nahoria',
      usericon: 'https://a.deviantart.net/avatars/n/a/nahoria.gif?5',
      type: 'premium',
      userId: 40391978,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 333,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/ryno-chalklut/art/F2U-Realistic-Base-Pack-750719317',
      title: '[F2U] Realistic Base Pack',
      author: {
        username: 'Ryno-Chalklut',
        usericon: 'https://a.deviantart.net/avatars/r/y/ryno-chalklut.gif?4',
        type: 'premium',
        userId: 39579831,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 52,
        favourites: 448,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/AGGyHaHbQDOb4laFq6CgOkj5Id4=/fit-in/150x150/filters:no_upscale():origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 112,
          width: 150,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/Wy9C0B8-O9DflgQxswOMQm8rqU0=/300x200/filters:fixed_height(100,100):origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 200,
          width: 267,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/dUweUDP8CkTb00EpS4MB9wFjjII=/fit-in/300x900/filters:no_upscale():origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 225,
          width: 300,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/7_ub5Ew4qNTMgOzuXaQ8KgRXc3M=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 250,
          width: 334,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/dUsx9bd1VZtvWWvbMDupLQ71gEw=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 350,
          width: 467,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/SS26hRNdLpdjscywNKMhZXNsna8=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 400,
          width: 534,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 774,
          width: 1033,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/182b/th/pre/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 774,
          width: 1033,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/96eb/f/2018/171/a/8/_f2u__realistic_base_pack_by_ryno_chalklut-dceyiqd.png',
          height: 1002,
          width: 1337,
          transparency: false,
          filesize: 277766,
          isDefault: false,
        },
      ],
      deviationId: 750719317,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-06-20T15:33:11-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 75690728,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Commissions',
    richDescription: undefined,

    owner: {
      username: 'Nahoria',
      usericon: 'https://a.deviantart.net/avatars/n/a/nahoria.gif?5',
      type: 'premium',
      userId: 40391978,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 35,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/hyeoii/art/OPEN-pin-up-themed-YCH-746725856',
      title: "[OPEN] 'pin-up' themed YCH",
      author: {
        username: 'Hyeoii',
        usericon: 'https://a.deviantart.net/avatars/h/y/hyeoii.gif?5',
        type: 'premium',
        userId: 25563014,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 19,
        favourites: 48,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/dH--8iOfhaWvYITCRdsfr1R9xEo=/fit-in/150x150/filters:no_upscale():origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 150,
          width: 108,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/A8pUUf7qOX0QeQ9UoTFlwOZ4Pz4=/300x200/filters:fixed_height(100,100):origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 200,
          width: 144,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/JhMroV6mlLLy5NKviyl08zrOabs=/fit-in/300x900/filters:no_upscale():origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 415,
          width: 300,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/598Rmm8aNL4zEZI9WhNDk9AvXis=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 250,
          width: 181,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/VGmLd5MmIxwJuD2QEPa8HXqKrYk=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 350,
          width: 253,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/bZNBwZLsN7kmdX6w3JnGNS9Vx6A=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/88d4/th/pre/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 400,
          width: 289,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/d854/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 900,
          width: 650,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/d854/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 900,
          width: 650,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/d854/f/2018/178/f/5/_open___pin_up__themed_ych_by_hyeoii-dcckxcw.png',
          height: 900,
          width: 650,
          transparency: false,
          filesize: 188905,
          isDefault: false,
        },
      ],
      deviationId: 746725856,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-05-26T08:47:33-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 75732246,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Digital',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 432,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/laterush/art/117-742037883',
      title: '117',
      author: {
        username: 'LateRush',
        usericon: 'https://a.deviantart.net/avatars/l/a/laterush.jpg?2',
        type: 'regular',
        userId: 38167989,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 11,
        favourites: 177,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/E-DRJDKMpiqkdlRPkaVjqmzQ1F8=/fit-in/150x150/filters:no_upscale():origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 150,
          width: 115,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/Iuo4Ab3YhygE-hkUtDJrH5UJOj0=/300x200/filters:fixed_height(100,100):origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 200,
          width: 153,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/Sf83q4vpo2FqaRe4R57AkUIX4rk=/fit-in/300x900/filters:no_upscale():origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 391,
          width: 300,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/IDfzWjZzSr6O3bhuoSVM1rzwmvM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 250,
          width: 192,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/OwMfXvez1YuTfPNUV01MH5fnhCs=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 350,
          width: 269,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/30O43lbeebJ9ZMGu39VrADn20e0=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 400,
          width: 307,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 1021,
          width: 783,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/0a52/th/pre/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 1021,
          width: 783,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/8dd5/f/2018/115/9/0/117_final_by_laterush-dc9sg3f.jpg',
          height: 1920,
          width: 1473,
          transparency: false,
          filesize: 2578514,
          isDefault: false,
        },
      ],
      deviationId: 742037883,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-04-25T04:06:13-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 535603,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Vector-Vexel',
    richDescription: undefined,

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 1440,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/limkis/art/roses-bush-748657318',
      title: 'roses bush',
      author: {
        username: 'LimKis',
        usericon: 'https://a.deviantart.net/avatars/l/i/limkis.jpg?8',
        type: 'premium',
        userId: 2542417,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 4,
        favourites: 123,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/IoXs8RlsC69n0Aosr-U6076qO7U=/fit-in/150x150/filters:no_upscale():origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 93,
          width: 150,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/xQ77ubvK0PKTXMdh59wwxLXv448=/300x200/filters:fixed_height(100,100):origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 186,
          width: 300,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/PxvcmbEs8rd5xRO2iVVxzE0OyCo=/fit-in/300x900/filters:no_upscale():origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 186,
          width: 300,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/UBcL4Jmm7gPxX578XRnhEQ6yb1E=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 250,
          width: 403,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/vIx9hac9JCvbprsn_Rdgdi2DprQ=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 350,
          width: 564,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/4bB4iIPCJlhbXrBH0c_u6li0aRs=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 400,
          width: 645,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 704,
          width: 1135,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/dfe0/th/pre/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 704,
          width: 1135,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/7a83/f/2018/158/3/9/39da3c86241d076860b6ee83e67f52ae-dcdqbom.png',
          height: 2000,
          width: 3225,
          transparency: false,
          filesize: 2293787,
          isDefault: false,
        },
      ],
      deviationId: 748657318,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-06-07T10:50:10-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 527107,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Bahamas Road Trip',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 58,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/revedeaumermaid/art/ShallowBeach-563709529',
      title: 'ShallowBeach',
      author: {
        username: 'ReveDeauMermaid',
        usericon: 'https://a.deviantart.net/avatars/r/e/revedeaumermaid.jpg?3',
        type: 'regular',
        userId: 18057416,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 5,
        favourites: 53,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/urD40WiOkD_Nm1KEy9mrtVBf540=/fit-in/150x150/filters:no_upscale():origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 100,
          width: 150,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/sb_gjcxvOJ8yWSs1lOhQvAblVY4=/300x200/filters:fixed_height(100,100):origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 200,
          width: 300,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/dCy31uPldhd39vX-_vQhnW10GWw=/fit-in/300x900/filters:no_upscale():origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 200,
          width: 300,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/2dkUw3IGDqIlzuIKfltVA5upjUA=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 250,
          width: 375,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/lyYZJLAJNnxZDRMVZOlAFD4ceYs=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 350,
          width: 525,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/GjwqvmwQqTH-7YprdBQa64cl9co=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/2841/th/pre/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 400,
          width: 600,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/202d/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/202d/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/202d/i/2015/274/4/d/shallowbeach_by_revedeaumermaid-d9bm921.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 179901,
          isDefault: false,
        },
      ],
      deviationId: 563709529,
      typeId: 1,
      isJournal: false,
      publishedTime: '2015-10-01T20:34:48-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 64418092,
    parentId: null,
  },
  {
    type: 'collection',
    name: "Given Daily D's",

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 416,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/asher-bee/art/The-River-Mermaid-625725975',
      title: 'The River Mermaid',
      author: {
        username: 'Asher-Bee',
        usericon: 'https://a.deviantart.net/avatars/a/s/asher-bee.png?6',
        type: 'premium',
        userId: 1537191,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 70,
        favourites: 777,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/vn7QXX8CnCgW252GrEQ2WjHRgfM=/fit-in/150x150/filters:no_upscale():origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 150,
          width: 116,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/7ipgetMfF-n00G6-cedmHdWeXIg=/300x200/filters:fixed_height(100,100):origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 200,
          width: 155,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/liRpHtFYEiBBCkG8Z2UE44jGk1U=/fit-in/300x900/filters:no_upscale():origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 388,
          width: 300,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/9pSBcX6xkyQCsAFLq8jRYB1h1Do=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 250,
          width: 193,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/HoVDOrF06JAgRo2m-oBdQaDm8q0=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 350,
          width: 270,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/2RhxLrLtuhKXhmkM1yNybqbkAC4=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 400,
          width: 309,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 1017,
          width: 786,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/2918/th/pre/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 1017,
          width: 786,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/ca28/i/2016/215/a/e/the_river_mermaid_by_asher_bee-dacjh93.png',
          height: 1165,
          width: 900,
          transparency: false,
          filesize: 1469186,
          isDefault: false,
        },
      ],
      deviationId: 625725975,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-08-02T23:53:46-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 1837524,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Nintendo',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 376,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/turtle-arts/art/Skullkid-Redraw-760609321',
      title: 'Skullkid Redraw',
      author: {
        username: 'Turtle-Arts',
        usericon: 'https://a.deviantart.net/avatars/t/u/turtle-arts.gif',
        type: 'premium',
        userId: 10588129,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 12,
        favourites: 286,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/J_CuLUIDnM947VP1t6CqwJayiEE=/fit-in/150x150/filters:no_upscale():origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 136,
          width: 150,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/U9f-NFRHHD09GUixryRBn-FKAHw=/300x200/filters:fixed_height(100,100):origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 200,
          width: 221,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/nmJ1rYCLAEFRYYMRL-WdFLPXlqw=/fit-in/300x900/filters:no_upscale():origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 272,
          width: 300,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/SYkZXHS_qiTWSWZayFqHpORE1PM=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 250,
          width: 276,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/0GIMcph4OlAyAxO5A7-rMyEpIY8=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 350,
          width: 386,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/OCzDuWkCHh7LMc8QgpOInYdrMTg=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/41ee/th/pre/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 400,
          width: 441,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/1f2c/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 816,
          width: 900,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/1f2c/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 816,
          width: 900,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/1f2c/f/2018/234/0/3/032e35ec9fb85b6f01e81a0ec0041f20-dckuhwp.jpg',
          height: 816,
          width: 900,
          transparency: false,
          filesize: 526340,
          isDefault: false,
        },
      ],
      deviationId: 760609321,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-08-22T07:50:53-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 66685629,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Photography',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 103,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/jestephotography/art/Bohemian-Waxwing-Dreams-of-light-664851268',
      title: 'Bohemian Waxwing - Dreams of light',
      author: {
        username: 'JestePhotography',
        usericon:
          'https://a.deviantart.net/avatars/j/e/jestephotography.jpg?10',
        type: 'premium',
        userId: 28135901,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 100,
        favourites: 1424,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/5m2aS9wV7fGzBiGcSVIvQKCOcQI=/fit-in/150x150/filters:no_upscale():origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 100,
          width: 150,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/F5Gk0FSR5ddGHUcqvwoZ2Fgh2lk=/300x200/filters:fixed_height(100,100):origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 200,
          width: 300,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/R1mmNE55n4i4lqHI3usyn6I-ing=/fit-in/300x900/filters:no_upscale():origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 200,
          width: 300,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/zUkxmV5a2zr7EzmOuad1UtR8eK8=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 250,
          width: 375,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/hH2cTDesOTPh_PnBfTb8duoDY_M=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 350,
          width: 525,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/4rHdklbjBXrWcPHVx2e6lA5M9-c=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/0dc7/th/pre/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 400,
          width: 600,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/b32b/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/b32b/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/b32b/i/2017/051/7/0/bohemian_waxwing___dreams_of_light_by_jestephotography-dazu2is.jpg',
          height: 683,
          width: 1024,
          transparency: false,
          filesize: 87265,
          isDefault: false,
        },
      ],
      deviationId: 664851268,
      typeId: 1,
      isJournal: false,
      publishedTime: '2017-02-20T21:22:33-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 535542,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Resources',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 130,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/peterpateman/art/Driftwood-sunset-329058394',
      title: 'Driftwood sunset',
      author: {
        username: 'peterpateman',
        usericon: 'https://a.deviantart.net/avatars/p/e/peterpateman.jpg?8',
        type: 'regular',
        userId: 13985011,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 66,
        favourites: 157,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/iMBKE-hAqz-C3E2MYBrBHEY6okg=/fit-in/150x150/filters:no_upscale():origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 112,
          width: 150,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/DNtzNPCeHRfRS8R5nCPCkATuL7c=/300x200/filters:fixed_height(100,100):origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 200,
          width: 267,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/qDHYM4mlHoTznWAnmJ47Ba1ntdY=/fit-in/300x900/filters:no_upscale():origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 225,
          width: 300,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/9aSi2N_eBsR7G_6LrhsxxZP43hk=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 250,
          width: 333,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/GJW9Dz7VWR3VJZkoIfncgX835-o=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 350,
          width: 467,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/SflrgCAUdos_0dcUM9EKGia4Vqc=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 400,
          width: 533,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 774,
          width: 1032,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/ecbc/th/pre/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 774,
          width: 1032,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/891c/f/2012/268/2/d/driftwood_sunset_by_peterpateman-d5fwv2y.jpg',
          height: 1931,
          width: 2575,
          transparency: false,
          filesize: 2586713,
          isDefault: false,
        },
      ],
      deviationId: 329058394,
      typeId: 1,
      isJournal: false,
      publishedTime: '2012-09-24T19:02:26-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 532777,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Mac',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 38,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/linebirgitte/art/Fluffies-Pack-189838924',
      title: 'Fluffies Pack',
      author: {
        username: 'LineBirgitte',
        usericon: 'https://a.deviantart.net/avatars/l/i/linebirgitte.gif?4',
        type: 'senior',
        userId: 7406069,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 41,
        favourites: 31,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/KNWzGNoLfTCcdJoqJRFYWMN6VLI=/fit-in/150x150/filters:no_upscale():origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 150,
          width: 86,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/AM19VCaSgrbjcD65JCGPUf2wSag=/300x200/filters:fixed_height(100,100):origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 200,
          width: 115,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/Mfbncioev5dC9-SQPHvuc9Ra3zE=/fit-in/300x900/filters:no_upscale():origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 523,
          width: 300,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/qAA2QgYqmqKgj5kaimS-WuSr12Y=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 250,
          width: 143,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/vw02RrfP6-WGCcf_hzSyDQqnfB4=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 350,
          width: 201,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/y05t4HjC63HHOXbOpmIP2EXHQK8=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 400,
          width: 229,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 1181,
          width: 677,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/103c/th/pre/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 1181,
          width: 677,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/60c1/i/2010/350/5/7/fluffies_pack_by_brgtt-d350wng.png',
          height: 1238,
          width: 710,
          transparency: false,
          filesize: 441801,
          isDefault: false,
        },
      ],
      deviationId: 189838924,
      typeId: 1,
      isJournal: false,
      publishedTime: '2010-12-16T19:27:01-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 549931,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Babs',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 25,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/shuttermonkey/art/Landing-Lake-152905066',
      title: 'Landing Lake',
      author: {
        username: 'shuttermonkey',
        usericon: 'https://a.deviantart.net/avatars/s/h/shuttermonkey.gif?3',
        type: 'senior',
        userId: 533453,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 25,
        favourites: 45,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/BSz8TQPm-fG-hIwKYzxMR2ypIZw=/fit-in/150x150/filters:no_upscale():origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 150,
          width: 96,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/56XjPP_7SJlpzvEYuhfvPNrjpmM=/300x200/filters:fixed_height(100,100):origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 200,
          width: 128,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/ZmniGAib8on5Jpeimd1MCYW4I3I=/fit-in/300x900/filters:no_upscale():origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 470,
          width: 300,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/XT9c5lgPg5_mspbkxYQLOAauMM0=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 250,
          width: 160,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/cLp_2jxVuTA2IE3LSZ0Y6F0wCSI=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 350,
          width: 223,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/TxUBGl_ov3jd5isDv5YmE0guNpw=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/05bd/th/pre/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 400,
          width: 255,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/8f0a/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 760,
          width: 485,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/8f0a/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 760,
          width: 485,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/8f0a/f/2010/035/7/c/landing_lake_by_shuttermonkey.jpg',
          height: 760,
          width: 485,
          transparency: false,
          filesize: 322349,
          isDefault: false,
        },
      ],
      deviationId: 152905066,
      typeId: 1,
      isJournal: false,
      publishedTime: '2010-02-04T13:20:41-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 887468,
    parentId: null,
  },
  {
    type: 'collection',
    name: "Logo's",

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 9,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/theryanford/art/DeviantART-Logo-137353891',
      title: 'DeviantART Logo',
      author: {
        username: 'TheRyanFord',
        usericon: 'https://a.deviantart.net/avatars/t/h/theryanford.png?2',
        type: 'senior',
        userId: 13025,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 168,
        favourites: 427,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/RgcEdg_qckGqlXmGA1xguC6xL_I=/fit-in/150x150/filters:no_upscale():origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 78,
          width: 150,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/qmBxjTOAKFv0oCpX3NiPzVly5XI=/300x200/filters:fixed_height(100,100):origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 157,
          width: 300,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/kIAngMtSFSqVtXBAFWA3nC45v1Q=/fit-in/300x900/filters:no_upscale():origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 157,
          width: 300,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/UvkPrwSGzs-RQAktOp3lOGz0wvk=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 250,
          width: 479,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/snOvib7cVvKTmo3_30M_Gw86Is8=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 350,
          width: 670,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/kzsJj_ILWW1UOjYchUmSndjzjsM=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/e2e0/th/pre/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 400,
          width: 766,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/5158/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 486,
          width: 931,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/5158/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 486,
          width: 931,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/5158/f/2009/260/0/8/08a905d1fa3212a3b5d70aac12a967a8.png',
          height: 486,
          width: 931,
          transparency: false,
          filesize: 140792,
          isDefault: false,
        },
      ],
      deviationId: 137353891,
      typeId: 1,
      isJournal: false,
      publishedTime: '2009-09-17T16:11:25-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 1642027,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Stamps',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 98,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/ginkgografix/art/i-heart-fella-431628720',
      title: 'i heart fella',
      author: {
        username: 'ginkgografix',
        usericon: 'https://a.deviantart.net/avatars/g/i/ginkgografix.gif?5',
        type: 'senior',
        userId: 3878204,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 21,
        favourites: 52,
      },
      files: [
        {
          type: '150',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/a202/f/2014/034/b/1/stamp_by_ginkgografix-d74zauo.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 9428,
          isDefault: false,
        },
      ],
      deviationId: 431628720,
      typeId: 1,
      isJournal: false,
      publishedTime: '2014-02-03T13:46:30-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 549965,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Chu-Tastic',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 47,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/ry-spirit/art/Kingchu-747817601',
      title: 'Kingchu',
      author: {
        username: 'Ry-Spirit',
        usericon: 'https://a.deviantart.net/avatars/r/y/ry-spirit.gif?7',
        type: 'senior',
        userId: 5389352,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 45,
        favourites: 1130,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/oQtaLy_ZUuEUHOEjERRQKCaom7g=/fit-in/150x150/filters:no_upscale():origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 150,
          width: 121,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/xJGHVZgbHBqi2azEdrqikb_sNmM=/300x200/filters:fixed_height(100,100):origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 200,
          width: 162,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/n9inPsrKUKCmw1Zy32EHtjmMk8I=/fit-in/300x900/filters:no_upscale():origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 371,
          width: 300,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/wrN5ifnRY6HtD-QXYroKbwHy9BI=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 250,
          width: 202,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/rFTsfocH1-T9zA3_QtPKAaUpgb0=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 350,
          width: 283,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/8BjaspDNVxRU5MdTexHyD3AM-2w=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/9a01/th/pre/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 400,
          width: 324,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/a311/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 741,
          width: 600,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/a311/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 741,
          width: 600,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/a311/i/2018/153/a/e/kingchu_by_ry_spirit-dcd8br5.png',
          height: 741,
          width: 600,
          transparency: true,
          filesize: 436169,
          isDefault: false,
        },
      ],
      deviationId: 747817601,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-06-02T03:19:30-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 39547395,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'News',
    richDescription: undefined,

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 274,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/heidi/journal/Upcoming-Site-Changes-and-Your-Involvement-752774759',
      title: 'Upcoming Site Changes and Your Involvement',
      author: {
        username: 'Heidi',
        usericon: 'https://a.deviantart.net/avatars/h/e/heidi.gif?13',
        type: 'admin',
        userId: 31,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 3664,
        favourites: 977,
      },
      files: [
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          height: 220,
          width: 500,
          transparency: false,
          isDefault: true,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/b7d7/i/2018/184/7/d/untitled_by_danlev-dcg7ahy.jpg',
          height: 537,
          width: 1024,
          transparency: false,
          filesize: 118994,
          isDefault: true,
        },
      ],
      deviationId: 752774759,
      typeId: 1,
      isJournal: true,
      publishedTime: '2018-07-03T17:22:22-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],

      textContent: {
        excerpt:
          "About a year and a half ago, we posted a journal discussing how DeviantArt’s acquisition would grant us the resources to make many positive changes for the site.  Thus far, a lot of such improvements haven’t been entirely obvious — like the many new hires across all departments (we've more than doubled our staff!) or upgrades to the tools we use behind-the-scenes.  All of this was done in order to bring you big-ticket changes, including a much-improved and redesigned site.\n\nWe've approached the redesign with a lot of consideration, which is why it’s been in development for so long.  Not only do there continue to be len",
        html: {
          type: 'writer',
          features: '',
        },
      },
    },
    folderId: 45037013,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Journals',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 109,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/heidi/journal/Celebrating-Artist-Evolution-757519255',
      title: 'Celebrating Artist Evolution!',
      author: {
        username: 'Heidi',
        usericon: 'https://a.deviantart.net/avatars/h/e/heidi.gif?13',
        type: 'admin',
        userId: 31,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 513,
        favourites: 151,
      },
      files: [
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          height: 220,
          width: 500,
          transparency: false,
          isDefault: true,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/64a4/f/2018/218/1/a/lineart1_by_dtab428-dcjf0hg.png',
          height: 654,
          width: 540,
          transparency: false,
          filesize: 483281,
          isDefault: true,
        },
      ],
      deviationId: 757519255,
      typeId: 1,
      isJournal: true,
      publishedTime: '2018-08-06T23:01:33-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],

      textContent: {
        excerpt:
          "It's DeviantArt’s 18th birthday and we want to celebrate with you! Check out our festive Line Art Challenge, Artist Evolution Spotlight, and learn how to get our special Birthday Badge!\n\nGET THE BADGE\n\n18th BirthdayArtist Evolution\n\nTwitter\n\nFacebook\n\nGoogle+\n\nArtist  EvolutionSee how deviant artists have evolved with DeviantArt!\n\nTo commemorate this landmark birthday (DeviantArt can now buy lottery tickets and vote!), we're taking a moment to appreciate how far we've come.  We talked to nine longtime deviants to discover how they progressed from their early days as artists. \nAfter seeing their artistic evolutions, share your own in the",
        html: {
          type: 'writer',
          features: '',
        },
      },
    },
    folderId: 45086814,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Contests',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 29,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/go/journal/Ripley-s-Unconventional-Art-Contest-754841619',
      title: "Ripley's Unconventional Art Contest",
      author: {
        username: 'GO',
        usericon: 'https://a.deviantart.net/avatars/g/o/go.png?4',
        type: 'admin',
        userId: 37876482,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 441,
        favourites: 297,
      },
      files: [
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          height: 220,
          width: 500,
          transparency: false,
          isDefault: true,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/b80d/f/2018/204/e/7/ripleys_og_by_symonx-dci23ob.jpg',
          height: 400,
          width: 600,
          transparency: false,
          filesize: 87439,
          isDefault: true,
        },
      ],
      deviationId: 754841619,
      typeId: 1,
      isJournal: true,
      publishedTime: '2018-08-01T13:25:29-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],

      textContent: {
        excerpt:
          "Break out of the box with our #UnconventionalArtContest! Your unique piece could win you $3,000 and more great prizes courtesy of RipleyS (https://www.deviantart.com/ripleys)!\n\nContestView EntriesOfficial Rules\n\n13+ International\n\nTwitter\n\nFacebook\n\nGoogle+\n\nDeviantArt, in collaboration with Ripley's Believe It or Not!, wants you to break out of your creative norms and take part in the Unconventional Art Contest!\nInspired by Ripley's Believe It or Not! Odd Is Art, a book showcasing innovative art, we challenge you to change up your usual process and create pieces using unconventional means. From painting to sculptures and everything in between, undertake an artistic experiment",
        html: {
          type: 'writer',
          features: '',
        },
      },
    },
    folderId: 58150228,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Made for Chu',
    richDescription: undefined,

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 17,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/dekoradum/art/STAMP-Ikue-198123964',
      title: '::STAMP:: Ikue',
      author: {
        username: 'dekorAdum',
        usericon: 'https://a.deviantart.net/avatars/d/e/dekoradum.png?9',
        type: 'senior',
        userId: 12852404,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 2,
        favourites: 12,
      },
      files: [
        {
          type: '150',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/43ca/f/2011/051/c/5/c50e4dd5d40a8d7540c2934d55ea1dfd-d39yhfg.png',
          height: 56,
          width: 99,
          transparency: true,
          filesize: 6031,
          isDefault: false,
        },
      ],
      deviationId: 198123964,
      typeId: 1,
      isJournal: false,
      publishedTime: '2011-02-20T01:29:16-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 39222487,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Our Story',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 19,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/katiealves/art/Deviant-Art-Inspired-Black-Light-Makeup-498329756',
      title: 'Deviant Art Inspired Black Light Makeup',
      author: {
        username: 'KatieAlves',
        usericon: 'https://a.deviantart.net/avatars/k/a/katiealves.jpg?5',
        type: 'senior',
        userId: 13980035,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 31,
        favourites: 919,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/bq_ys6MrKRConB7ikmYc6nFK11s=/fit-in/150x150/filters:no_upscale():origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 73,
          width: 150,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/MKyyiciCC_vnu3fcpUe3SZQfhuI=/300x200/filters:fixed_height(100,100):origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 146,
          width: 300,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/yH6g4q39FuOE10qNwb7gd6sAdyc=/fit-in/300x900/filters:no_upscale():origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 146,
          width: 300,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/BWGC-jo_ojjOVebd5sv1Hq_xJDU=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 244,
          width: 500,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/vDc8l9wd3s2i8405j6dF0scv15s=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 341,
          width: 700,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/gs7g5iZAnYMqniK82psy0NzMT4k=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/8f52/th/pre/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 390,
          width: 800,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://img00.deviantart.net/c9f4/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 499,
          width: 1024,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://img00.deviantart.net/c9f4/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 499,
          width: 1024,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/c9f4/i/2014/338/4/5/deviant_art_inspired_black_light_makeup_by_katiealves-d88oxp8.jpg',
          height: 499,
          width: 1024,
          transparency: false,
          filesize: 157802,
          isDefault: false,
        },
      ],
      deviationId: 498329756,
      typeId: 1,
      isJournal: false,
      publishedTime: '2014-12-04T15:44:20-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: false,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 69072695,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Creative Calendar',

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 24,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/thiefoworld/art/Somewhere-644773791',
      title: 'Somewhere',
      author: {
        username: 'Thiefoworld',
        usericon: 'https://a.deviantart.net/avatars/t/h/thiefoworld.gif',
        type: 'volunteer',
        userId: 1733358,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 1,
        favourites: 39,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/BCTSB5i_O2f-Vv_Fmco39rQeKzQ=/fit-in/150x150/filters:no_upscale():origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 150,
          width: 150,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/E_nKSvrQale_QhHg4kp4uZVpcxU=/300x200/filters:fixed_height(100,100):origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 200,
          width: 200,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/d1YYHzSkoWRycozcVnre4-_6MHQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 300,
          width: 300,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/p_z-7dzH2I2Q1tfi5VPrV2UE7rA=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 250,
          width: 250,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/ZB_D7MhXQ1lHPa6tfXz0QIXJWBM=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 350,
          width: 350,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/QX8-kvy5l7dCDJTlowsel4rBBas=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/115e/th/pre/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 400,
          width: 400,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://orig00.deviantart.net/241a/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 492,
          width: 492,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://orig00.deviantart.net/241a/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 492,
          width: 492,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/241a/f/2016/313/c/f/somewhere_by_thiefoworld-danvqn3.png',
          height: 492,
          width: 492,
          transparency: false,
          filesize: 393849,
          isDefault: false,
        },
      ],
      deviationId: 644773791,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-12-24T06:13:37-0800',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 71780373,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Breath of the Wild',
    richDescription: undefined,

    owner: {
      username: 'Ikue',
      usericon: 'https://a.deviantart.net/avatars/i/k/ikue.gif?3',
      type: 'admin',
      userId: 515001,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 26,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/eternalegend/art/Breath-Of-The-Wild-Old-Man-643995835',
      title: 'Breath Of The Wild: Old Man',
      author: {
        username: 'EternaLegend',
        usericon: 'https://a.deviantart.net/avatars/e/t/eternalegend.png?6',
        type: 'regular',
        userId: 5456604,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: {
        comments: 17,
        favourites: 817,
      },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/guX4PC2V-_0q9M4PqOUJ5a7pImI=/fit-in/150x150/filters:no_upscale():origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 150,
          width: 112,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/3B4e-t9w763WWqL4Bj9A5QjirrU=/300x200/filters:fixed_height(100,100):origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 200,
          width: 150,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/Mw_CGh8ScqlR_Svnv33fN01BbXQ=/fit-in/300x900/filters:no_upscale():origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 400,
          width: 300,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/rVftL1zRNsvmixu9KA8wpD3gFDI=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 250,
          width: 187,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/KMjVs9qrz8ExizMmtiTqJetY6ow=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 350,
          width: 262,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/_dHpOFJRcg_Ahx5kRx945o_ldTc=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 400,
          width: 300,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 1032,
          width: 774,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/452b/th/pre/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 1032,
          width: 774,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://orig00.deviantart.net/02e5/f/2016/309/3/b/breath_of_the_wild__old_man_by_eternalegend-danf2d7.jpg',
          height: 1067,
          width: 800,
          transparency: false,
          filesize: 441163,
          isDefault: false,
        },
      ],
      deviationId: 643995835,
      typeId: 1,
      isJournal: false,
      publishedTime: '2016-11-04T16:43:43-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 72134391,
    parentId: null,
  },
  {
    type: 'collection',
    name: 'Featured',

    owner: {
      username: 'yury-n',
      usericon: 'https://a.deviantart.net/avatars/y/u/yury-n.jpg?2',
      type: 'admin',
      userId: 15691842,
      useridUuid: '',
      isNewDeviant: true,
    },
    size: 181,
    additionalThumbs: null,
    thumb: {
      url: 'https://www.deviantart.com/snatti89/art/Whale-migration-752744386',
      title: 'Whale migration',
      author: {
        username: 'snatti89',
        usericon: 'https://a.deviantart.net/avatars/s/n/snatti89.jpg?2',
        type: 'regular',
        userId: 19120637,
        useridUuid: '',
        isNewDeviant: true,
      },
      stats: { comments: 49, favourites: 1694 },
      files: [
        {
          type: '150',
          src: 'https://t00.deviantart.net/pjm2fk6FiS8cC6seMdObezM1JpU=/fit-in/150x150/filters:no_upscale():origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 150,
          width: 128,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: '200H',
          src: 'https://t00.deviantart.net/DcSWC70oz46yO_bKV8sGZb6jqsE=/300x200/filters:fixed_height(100,100):origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 200,
          width: 171,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: '300W',
          src: 'https://t00.deviantart.net/N6VVdc7O8BoDOVj1Yyu2Xu4YVOM=/fit-in/300x900/filters:no_upscale():origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 351,
          width: 300,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: '250T',
          src: 'https://t00.deviantart.net/JNRiXQE6ffqvKSg5C58QYO0tjTo=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 250,
          width: 214,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: '350T',
          src: 'https://t00.deviantart.net/-9JwxgiUXDC2I3pT0zbKQoKX_j8=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 350,
          width: 300,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: '400T',
          src: 'https://t00.deviantart.net/uautkf2MA7LfWbqir9AAPJcME4k=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 400,
          width: 342,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: 'preview',
          src: 'https://pre00.deviantart.net/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 966,
          width: 827,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: 'social_preview',
          src: 'https://pre00.deviantart.net/d279/th/pre/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 966,
          width: 827,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
        {
          type: 'fullview',
          src: 'https://img00.deviantart.net/5396/i/2018/184/6/0/whale_migration_by_snatti89-dcg5xaa.png',
          height: 1196,
          width: 1024,
          transparency: false,
          filesize: 1618416,
          isDefault: false,
        },
      ],
      deviationId: 752744386,
      typeId: 1,
      isJournal: false,
      publishedTime: '2018-07-03T08:58:03-0700',
      isTextEditable: false,
      legacyTextEditUrl: null,
      isShareable: true,
      isCommentable: true,
      isFavourited: false,
      isDeleted: false,
      isMature: false,
      isDownloadable: true,
      isAntisocial: false,
      isBlocked: false,
      isPurchasable: false,
      blockReasons: [],
    },
    folderId: 41656492,
    parentId: null,
  },
];

export const collectionsFolderAll: PapiGallection = {
  type: 'collection',
  parentId: null,
  name: 'All',

  owner: {
    username: 'puimun',
    usericon: 'https://a.deviantart.net/avatars/p/u/puimun.jpg?1',
    type: 'regular',
    userId: 528733,
    useridUuid: '',
    isNewDeviant: true,
  },
  size: 1433,
  additionalThumbs: null,
  thumb: {
    url: 'https://www.deviantart.com/u-hj12h323/shiniez/art/mercy-85-93-742852179',
    title: 'mercy 85-93',
    author: {
      username: 'shiniez',
      usericon: 'https://a.deviantart.net/avatars/s/h/shiniez.jpg?4',
      type: 'premium',
      userId: 19760720,
      useridUuid: '',
      isNewDeviant: true,
    },
    stats: {
      comments: 321,
      favourites: 1008,
    },
    files: [
      {
        type: '150',
        src: 'https://t00.deviantart.net/W315SRMN9PvgeR2INogetDYtMhg=/fit-in/150x150/filters:no_upscale():origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 150,
        width: 11,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: '200H',
        src: 'https://t00.deviantart.net/RqAxk39NF6WpIeh33umhMioIv0c=/300x200/filters:fixed_height(100,100):origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 201,
        width: 100,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: '300W',
        src: 'https://t00.deviantart.net/c8Tt__7B_rmpEVsIiNqmtGwzdG4=/fit-in/300x900/filters:no_upscale():origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 900,
        width: 69,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: '250T',
        src: 'https://t00.deviantart.net/hbCxky1xCi7p3ty66mk-Yk2Fk3g=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 250,
        width: 19,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: '350T',
        src: 'https://t00.deviantart.net/LEAXSg29i1RnhxA25B7r0_SMxdE=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 350,
        width: 27,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: '400T',
        src: 'https://t00.deviantart.net/cORW0KuJzwVl8Moe0iRlDyizTrA=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 400,
        width: 31,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: 'preview',
        src: 'https://pre00.deviantart.net/e877/th/pre/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 3237,
        width: 247,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
      {
        type: 'social_preview',
        src: 'https://st.deviantart.net/misc/noentrythumb-200.png',
        height: 200,
        width: 200,
        transparency: false,
        isDefault: false,
      },
      {
        type: 'fullview',
        src: 'https://orig00.deviantart.net/7709/f/2018/120/b/2/mercy_85_93_by_shiniez-dca9wer.jpg',
        height: 13100,
        width: 1000,
        transparency: false,
        filesize: 1851245,
        isDefault: false,
      },
    ],
    deviationId: 742852179,
    typeId: 1,
    publishedTime: '2018-04-30T12:52:51-0700',
    isJournal: false,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: true,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPurchasable: false,
    blockReasons: [],
  },
  folderId: -1,
};
